import React, { FC } from 'react';
import { IPriceV2, IPriceV2Types } from '../../../../services/features/featureList.types';
import { getDealerFeesSum, getTotalPriceObjByType } from '@utils/Price.utils';
// import { EMPLOYEE_PRICE_TYPE } from '../../../../services/filters/filters';
import { useMoneyFormatter } from '@hooks/useMoneyFormatter';
import PriceSuffix from '../../../PriceSuffix';
import { useFeatureSwitchEnabled } from '@hooks/useFeatureSwitchEnabled';
import { FEATURES_LIST } from '../../../../context/featureSwitchApp';
import { IConfigurableCar } from 'src/interfaces/Car';
import { IDealerFee } from '@components/DealerFees/DealerFeesTemplate';
// import { IS_B2C } from '../../../../constants/main';
// import useTranslations from '@hooks/useTranslations';

interface IDealCashPriceProps {
    prices: IPriceV2[];
    fullProductConfiguration: IConfigurableCar;
}

const DealCashPrice: FC<IDealCashPriceProps> = ({ prices, fullProductConfiguration }: IDealCashPriceProps) => {
    // const { t } = useTranslations();
    const basicCarPriceObjTotalB2C: IPriceV2 = getTotalPriceObjByType(prices, IPriceV2Types.TOTAL_B2C_CASH);
    const isSOLEnabled = useFeatureSwitchEnabled(FEATURES_LIST.FEATURE_SWITCH_SOL_ENABLED);
    const isDealerFeesEnabled = useFeatureSwitchEnabled(FEATURES_LIST.FEATURE_SWITCH_DEALER_FEES_ENABLED);

    const accessoriesPrice = fullProductConfiguration?.importInputs?.accessoriesPrice || 0;
    const feesPrice = getDealerFeesSum(fullProductConfiguration?.fees, isDealerFeesEnabled).withVAT;

    const cashPrice =
        (isSOLEnabled
            ? basicCarPriceObjTotalB2C.breakdown.finalCustomerCashPriceOnTheRoad ||
              basicCarPriceObjTotalB2C.breakdown.finalCustomerPriceOnTheRoad
            : basicCarPriceObjTotalB2C.localNetPriceInclTax) +
        accessoriesPrice +
        feesPrice;

    // const cataloguePrice: IPrice = getTotalPriceObjByType(prices, CATALOGUE_PRICE_TYPE);

    const { formatMoney } = useMoneyFormatter();

    return (
        <div className="price">
            <div className="big-price">
                <div data-testid="TESTING_STORE_PRICE" className="price-value">
                    {formatMoney(cashPrice)}
                </div>
                <div className="suffix">
                    <PriceSuffix />
                </div>
            </div>

            {/* TODO: !!Do not uncomment before January 2021, because SOL FR is not presenting former prices now. */}
            {/*<div data-testid="cut-price-value" className="price-value-b2c">
                {t('myaccount.mySaves.cataloguePrice')} {formatMoney(employeePrice.localNetPriceInclTax)}
            </div> */}

            {/*<div className="cut-price">
                <div data-testid="cut-price-value" className="price-value">
                    {formatMoney(cataloguePrice.basePrice)}
                </div>
                <PriceSuffix />
            </div>*/}
        </div>
    );
};

export default DealCashPrice;
